import { render, staticRenderFns } from "./CertNew.vue?vue&type=template&id=c5f8886c"
import script from "./CertNew.vue?vue&type=script&lang=js"
export * from "./CertNew.vue?vue&type=script&lang=js"
import style0 from "./CertNew.vue?vue&type=style&index=0&id=c5f8886c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports